import { render, staticRenderFns } from "./TeacherFeedBack.vue?vue&type=template&id=6a68eb32&"
import script from "./TeacherFeedBack.vue?vue&type=script&lang=js&"
export * from "./TeacherFeedBack.vue?vue&type=script&lang=js&"
import style0 from "./TeacherFeedBack.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TeacherFeedBack.vue"
export default component.exports